import { inject, Service } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FoodbackAccountContext } from '@core/classes/account/account-context.class';
import { AccountService } from '@core/providers/account/account.service';
import { NavigationService } from '@core/providers/navigation/navigation.service';

@Service()
export class VenueDashboardGuard {
  private accountService = inject(AccountService);
  private venueNavigationService = inject(NavigationService);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.accountService.getAccountContext$().pipe(
      map((data: FoodbackAccountContext) => {
        if (data.hasAccessTo().venueDashboard) {
          return true;
        }

        this.venueNavigationService.goToVenueOverview(route.params.venueId);

        return false;
      })
    );
  }
}
